var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-6"},[_c('div',{staticClass:"block"},[_c('h1',{staticClass:"title is-3 mt-2"},[_vm._v("Page Not Found")]),_c('p',[_vm._v(" Unfortunately the page you're looking for can't be found or there was an error in the link you followed or typed. ")]),_c('router-link',{attrs:{"to":{
        name: 'Dashboard'
      }}},[_c('div',{staticClass:"button mt-5"},[_vm._v("Go to Homepage")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }